import './App.scss';
import Testing from './components/Testing/Testing';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/testing/" replace />} />
          <Route path="/testing/*" element={<Testing />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
